import { ArquivoConciliacaoBancaria } from './../domain/arquivo-conciliacao-bancaria.model';
import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';

export class ArquivoConciliacaoBancariaSerializer extends DomainSerializer<ArquivoConciliacaoBancaria> {}
